import numeral from 'numeral'

import { Text } from '@loadsmart/loadsmart-ui'

import { RatePerMile } from 'offers/ui/RatePerMile'

import type { BookingType } from '../../domain/LoadOffer'
import { getSummaryRateLabel } from '../../presenters/loadSummaryPresenter'
import { Rate } from './LoadSummary.styles'

type LoadSummaryRateProps = {
  bookingType: BookingType
  price: number
  ratePerMile?: string
}

export function LoadSummaryRate({ bookingType, price, ratePerMile }: LoadSummaryRateProps) {
  return (
    <Rate>
      <Text as="div" variant="caption-bold" color="color-neutral-dark">
        {getSummaryRateLabel(bookingType)}
      </Text>
      <Text as="div" variant="heading-md-bold">
        {numeral(price).format('$0,0')}
      </Text>
      {ratePerMile && <RatePerMile ratePerMile={ratePerMile} />}
    </Rate>
  )
}
